export class ExtractorParams {
    isSync: boolean;
    extractedParams: object;
    hiddenExtractors: Array<string>;
}